import { DeepPartial } from 'react-hook-form';
import z from 'zod';

import { addressSchema } from '@utils/address';

const urlRegex = /^https?:\/\//i;

export const asvRegistrationSchema = z.object({
  company: z.object({
    name: z.string().min(1, 'Name is required'),
    website: z
      .string()
      .min(1, 'Website is required')
      .trim()
      .transform((v) => (urlRegex.test(v) ? v : `https://${v}`))
      .pipe(z.string().url('Invalid URL')),
    address: addressSchema,
  }),
  owner: z.object({
    name: z.string().min(1, 'Name is required'),
    title: z.string().min(1, 'Title is required'),
    email: z
      .string()
      .min(1, 'Email is required')
      .pipe(z.string().email('Invalid email')),
    phone: z.string().min(1, 'Phone is required'),
  }),
  allocatedIps: z.coerce.number().min(1, 'IP address count is required'),
});

export type AsvRegistrationSchema = z.infer<typeof asvRegistrationSchema>;

export const asvRegistrationDefaultValues: DeepPartial<AsvRegistrationSchema> =
  {
    company: {
      name: '',
      website: '',
      address: {
        line1: '',
        line2: '',
        city: '',
        postalCode: '',
        country: '',
      },
    },
    owner: {
      name: '',
      title: '',
      email: '',
      phone: '',
    },
    allocatedIps: undefined,
  };
